<script>
import EventBus from '@/EventBus'

export default {
  methods: {
    showPaymentError(errorResp, defaultMsg) {
      if (errorResp) {
        var resC = this.handleStripeCardResponse(errorResp)
        var msgToSend = resC.msgToSend
        var addonMsgToSend = resC.addonMsgToSend
        var toSend = this.$t(msgToSend)
        if (addonMsgToSend) {
          toSend = toSend + ' ' + this.$t(addonMsgToSend)
        }
        if (toSend === '' && defaultMsg) {
          toSend = this.$t(defaultMsg)
        }

        if (toSend !== '') {
          EventBus.$emit('new-info-bar-msg', {
            msg: toSend,
            error: true,
          })
          return true
        }
      }
      return false
    },
    handleStripeCardResponse(res) {
      var ret
      var msgToSend
      var addonMsgToSend
      if (res.error) {
        if (res.error.code === 'tax_id_invalid') {
          msgToSend = 'invalidVatNumber'
          if (this.$refs.vatId) {
            this.$refs.vatId.setIncorrect()
          }
          // check if variable exists
          this.incorrectNipText = this.$t('invalidVatNumber')
        } else if (res.error.code === 'nip_invalid') {
          msgToSend = 'invalidNIPNumber'
          if (this.$refs.vatId) {
            this.$refs.vatId.setIncorrect()
          }
          // check if variable exists
          this.incorrectNipText = this.$t('invalidNIPNumber')
        } else if (res.error.code == 'incorrect_cvc') {
          msgToSend = 'incorrectCVC'
          // check if variable exists
          this.incorrectCvv = true
        } else if (res.error.code == 'processing_error') {
          msgToSend = 'processingError'
          addonMsgToSend = 'pleaseContactSupport'
          // check if variable exists
          this.incorrectNumber = true
        } else if (res.error.code == 'invalid_expiry_month') {
          msgToSend = 'invalidExpiryMonth'
          // check if variable exists
          this.incorrectExpiry = true
        } else if (res.error.code == 'invalid_expiry_year') {
          msgToSend = 'invalidExpiryYear'
          // check if variable exists
          this.incorrectExpiry = true
        } else if (res.error.code == 'expired_card') {
          msgToSend = 'expiredCard'
          // check if variable exists
          this.incorrectNumber = true
        } else if (res.error.code == 'card_declined') {
          msgToSend = 'cardDeclined'
          if (res.error.decline_code == 'incorrect_number') {
            msgToSend = 'incorrectCardNumber'
            // check if variable exists
            this.incorrectNumber = true
          } else if (res.error.decline_code == 'insufficient_funds') {
            msgToSend = 'insufficientFunds'
          } else if (res.error.decline_code == 'lost_card') {
            msgToSend = 'lostCard'
          } else if (res.error.decline_code == 'stolen_card') {
            msgToSend = 'stolenCard'
          } else if (res.error.decline_code == 'card_not_supported') {
            msgToSend = 'cardNotSupported'
            // check if variable exists
            this.incorrectNumber = true
          } else {
            // check if variable exists
            this.incorrectNumber = true
          }
        }
      }
      if (msgToSend) {
        msgToSend = this.$t(msgToSend)
      }
      if (addonMsgToSend) {
        addonMsgToSend = this.$t(addonMsgToSend)
      }
      ret = { msgToSend, addonMsgToSend }

      return ret
    },
  },
}
</script>
